import OptionsList, { CheckBoxH, CheckBoxR, CheckBoxTime } from './optionsList';
import ColumnList from './tableCoulmns';
import dayjs from 'dayjs';

import { KoColorPicker, KoText } from 'packages';
import styles from './currentProperties.module.scss';

const now = dayjs();

const handleDownloadCSV = () => {
  const header = "value\n";
  const rows = ["Option 1", "Option 2"];
  const csvContent = header + rows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "sample-options.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const rgbToHex = (r, g, b) => {
  const toHex = (c) => {
    const hex = Math.round(c).toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const WosColor = ({ value, onChange }) => {

  const handleChange = (colorValue) => {
    const { r, g, b } = colorValue.metaColor;
    const hexColor = rgbToHex(r, g, b);
    onChange(hexColor);
  };
  return (
    <KoColorPicker value={value} defaultValue={'#000'} onChange={handleChange} />
  );
};

export const typeSpecificProperties = {
 
  heading: [
    {
      key: 'heading', placeholder: 'Enter heading', label: 'Heading Text', colSpan: 3, widget: 'input'
    },
    {
      key: 'level',
      placeholder: 'Select Heading',
      label: 'Heading',
      colSpan: 3,
      widget: 'select',
      defaultValue: 1,
      options: [
        { label: 'H1', value: 1 },
        { label: 'H2', value: 2 },
        { label: 'H3', value: 3 },
        { label: 'H4', value: 4 },
        { label: 'H5', value: 5 }
      ]
    },
    {
      key: 'align',
      label: 'Alignment',
      colSpan: 3,
      placeholder: 'Select alignment',
      widget: 'select',
      defaultValue: 'left',
      options: [
        { label: 'Left', value: 'left' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'right' }
      ]
    },
    {
      key: 'color',
      label: 'Text Color',
      colSpan: 3,
      defaultValue: "#000",
      widget: WosColor
    }
  ],
  subHeading: [
    {
      key: 'heading', placeholder: 'Enter heading', label: 'Heading Text', colSpan: 3, widget: 'input'
    },
    {
      key: 'level',
      placeholder: 'Select Heading',
      label: 'Heading',
      colSpan: 3,
      widget: 'select',
      defaultValue: 1,
      options: [
        { label: 'H1', value: 1 },
        { label: 'H2', value: 2 },
        { label: 'H3', value: 3 },
        { label: 'H4', value: 4 },
        { label: 'H5', value: 5 }
      ]
    },
    {
      key: 'align',
      label: 'Alignment',
      colSpan: 3,
      placeholder: 'Select alignment',
      widget: 'select',
      defaultValue: 'left',
      options: [
        { label: 'Left', value: 'left' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'right' }
      ]
    },
    {
      key: 'color',
      label: 'Text Color',
      colSpan: 3,
      defaultValue: "#000",
      widget: WosColor
    }
  ],
  select: [
    { key: 'isMultiSelect', label: '', colSpan: 3, widget: CheckBoxR },
    {
      key: 'min',
      label: 'Minimum Selection',
      colSpan: 1.5,
      placeholder: 'Ex: 1',
      widget: 'number'
    },
    {
      key: 'max',
      label: 'Maximum Selection',
      colSpan: 1.5,
      placeholder: 'Ex: 5',
      widget: 'number',
      hide: true
    },
    {
      key: 'options',
      placeholder: 'Enter options',
      label: <div>
        Options
        <KoText className={styles.sample} onClick={handleDownloadCSV} text="CSV Sample" />
      </div>,
      colSpan: 3,
      widget: OptionsList
    }

  ],
  radio: [
    { key: 'direction', label: '', colSpan: 3, widget: CheckBoxH },
    {
      key: 'options',
      placeholder: 'Enter choices',
      label: <div>
        Choices
        <KoText className={styles.sample} onClick={handleDownloadCSV} text="CSV Sample" />
      </div>,
      colSpan: 3,
      widget: OptionsList
    }

  ],
  checkbox: [
    { key: 'direction', label: '', colSpan: 3, widget: CheckBoxH },
    {
      key: 'min',
      label: 'Minimum Selection',
      colSpan: 1.5,
      placeholder: 'Ex: 1',
      widget: 'number'
    },
    {
      key: 'max',
      label: 'Maximum Selection',
      colSpan: 1.5,
      placeholder: 'Ex: 5',
      widget: 'number',
      hide: true
    },
    {
      key: 'options',
      placeholder: 'Enter choices',
      label: <div>
        Choices
        <KoText className={styles.sample} onClick={handleDownloadCSV} text="CSV Sample" />
      </div>,
      colSpan: 3,
      widget: OptionsList
    }

  ],
  slider: [
    { key: 'min', placeholder: 'Ex: 1', label: 'Start value', colSpan: 1.5, widget: 'number' },
    { key: 'max', placeholder: 'Ex: 1000', label: 'End value', colSpan: 1.5, widget: 'number' }
  ],
  date: [
    { key: 'time', label: '', colSpan: 3, widget: CheckBoxTime }
  ],
  time: [
    {
      key: 'fomat', label: 'Format', colSpan: 3, widget: 'select',
      defaultValue: 'hh:mma',
      options: [
        { label: `hh:mm:ss A (${now.format('hh:mm:ss A')})`, value: 'hh:mm:ss A' },
        { label: `hh:mm A (${now.format('hh:mm A')})`, value: 'hh:mm A' },
        { label: `hh:mm:ss a (${now.format('hh:mm:ssa')})`, value: 'hh:mm:ssa' },
        { label: `hh:mm a (${now.format('hh:mma')})`, value: 'hh:mma' },
        { label: `HH:mm:ss (${now.format('HH:mm:ss')})`, value: 'HH:mm:ss' },
        { label: `HH:mm (${now.format('HH:mm')})`, value: 'HH:mm' },
        { label: `mm:ss (${now.format('mm:ss')})`, value: 'mm:ss' }

      ]
    }
  ],
  upload: [
    { key: 'maxFiles', placeholder: 'Ex: 5', label: 'Max Files', colSpan: 1.5, widget: 'number' },
    { key: 'maxFileSize', placeholder: 'Ex: 10mb', label: 'Max File Size', colSpan: 1.5  },
    {
      key: 'accept', label: 'Accept file types', defaultValue: 'any', colSpan: 3, widget: 'select', options: [
        {
          "label": "All Files",
          "value": "any"
        },
        {
          "label": "Image",
          "value": "image"
        },
        {
          "label": "Video",
          "value": "video"
        },
        {
          "label": "Audio",
          "value": "audio"
        },
        {
          "label": "PDF",
          "value": "pdf"
        },
        {
          "label": "CSV",
          "value": "csv"
        },
        {
          "label": "XLS/XLSX",
          "value": "xls"
        },
        {
          "label": "DOC/DOCX",
          "value": "doc"
        },
        {
          "label": "PPT/PPTX",
          "value": "ppt"
        },
        {
          "label": "TXT",
          "value": "txt"
        },
        {
          "label": "RTF",
          "value": "rtf"
        },
        {
          "label": "JSON",
          "value": "json"
        },
        {
          "label": "XML",
          "value": "xml"
        },
        {
          "label": "YAML",
          "value": "yaml"
        },
        {
          "label": "ZIP",
          "value": "zip"
        },
        {
          "label": "RAR",
          "value": "rar"
        },
        {
          "label": "SVG",
          "value": "svg"
        },
        {
          "label": "EPS",
          "value": "eps"
        },
        {
          "label": "PSD",
          "value": "psd"
        },
        {
          "label": "AI (Illustrator)",
          "value": "ai"
        },
        {
          "label": "HTML",
          "value": "html"
        },
        {
          "label": "CSS",
          "value": "css"
        },
        {
          "label": "JavaScript",
          "value": "js"
        },
        {
          "label": "Python",
          "value": "py"
        },
        {
          "label": "Java",
          "value": "java"
        },
        {
          "label": "C",
          "value": "c"
        },
        {
          "label": "C++",
          "value": "cpp"
        }
      ]
    }
  ],
  yesno: [
    { key: 'checkedChildren', label: 'ON label', colSpan: 1.5 },
    { key: 'unCheckedChildren', label: 'OFF label', colSpan: 1.5 }
  ],
  textarea: [
    { key: 'rows', placeholder: 'Ex: 4', label: 'Rows', colSpan: 3, widget: 'number' },
    { key: 'min', placeholder: 'Ex: 1', label: 'Min Characters', colSpan: 1.5, widget: 'number' },
    { key: 'max', placeholder: 'Ex: 1000', label: 'Max Characters', colSpan: 1.5, widget: 'number' }
  ],
  input: [
    { key: 'min', placeholder: 'Ex: 1', label: 'Min Characters', colSpan: 1.5, widget: 'number' },
    { key: 'max', placeholder: 'Ex: 1000', label: 'Max Characters', colSpan: 1.5, widget: 'number' }

  ],
  number: [
    { key: 'min', placeholder: 'Ex: 1', label: 'Min value', colSpan: 1.5, widget: 'number' },
    { key: 'max', placeholder: 'Ex: 1000', label: 'Max value', colSpan: 1.5, widget: 'number' }

  ],
  richtext: [
    { key: 'toolbarOptions', placeholder: 'Toolbar config', label: 'Toolbar Options', colSpan: 3 }
  ],
  table: [
    {
      key: 'columns',
      placeholder: 'Enter columns',
      label: 'Columns',
      colSpan: 3,
      widget: ColumnList
    }
  ]
};
